import { deburr } from 'lodash';
export function slugify(input) {
    return deburr(input).toLowerCase().replace(/\W/g, ' ').trim().replace(/\s+/g, '-');
}
